'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDotSolidDotStroke, iconDotSolidDotStrokeTag } from '@ni/nimble-components/dist/esm/icons/dot-solid-dot-stroke';
import { wrap } from '../../utilities/react-wrapper';

export type { IconDotSolidDotStroke };
export { iconDotSolidDotStrokeTag };
export const NimbleIconDotSolidDotStroke = wrap(IconDotSolidDotStroke);